import React from 'react';
import { Table as SemanticTable } from 'semantic-ui-react';

const Table = ({ block }) => (
  <div style={{ overflowX: 'auto' }}>
    {block.caption && (
      <p style={{ fontStyle: 'italic', color: 'rgba(0, 0, 0, 0.6)' }}>{block.caption}</p>
    )}
    <SemanticTable celled stackable>
      <SemanticTable.Header>
        <SemanticTable.Row>
          {block.columns.map((column, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <SemanticTable.HeaderCell key={index}>{column}</SemanticTable.HeaderCell>
          ))}
        </SemanticTable.Row>
      </SemanticTable.Header>
      <SemanticTable.Body>
        {block.rows.map((row, rowIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <SemanticTable.Row key={rowIndex}>
            {row.map((cell, cellIndex) => (
              // eslint-disable-next-line react/no-array-index-key
              <SemanticTable.Cell key={cellIndex}>{cell}</SemanticTable.Cell>
            ))}
          </SemanticTable.Row>
        ))}
      </SemanticTable.Body>
    </SemanticTable>
  </div>
);

export default Table;
